import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export function IncludesSection() {
  return <section className="py-6 px-4 bg-white border-t border-gray-100" data-id="element-136">
      <div className="max-w-3xl mx-auto" data-id="element-137">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E]" data-id="element-138">
          ¿Qué incluye el Pack Efemérides Listas?
        </h2>

        <div className="bg-blue-50 rounded-2xl p-5 border border-blue-100 mb-5" data-id="element-139">
          <h3 className="text-2xl font-bold mb-3 text-[#000000]" data-id="element-140">
            📚 Ebook principal con efemérides desarrolladas de marzo a diciembre
          </h3>

          <div className="flex justify-center mb-4" data-id="element-141">
            <a href="#compra" className="cursor-pointer hover:opacity-95 transition-opacity" data-id="element-142">
              <img src="https://cdn.magicpatterns.com/uploads/anbkPXfQGWewVMjCirizg3/MOCKAP_PRINCIPAL.png" alt="Pack Efemérides Listas" className="w-[180px] h-auto object-contain drop-shadow-lg rounded-lg" data-id="element-143" />
            </a>
          </div>

          <p className="text-lg font-medium mb-2" data-id="element-144">Cada fecha incluye:</p>

          <ul className="space-y-1.5 text-lg text-gray-800 mb-4 pl-4" data-id="element-145">
            <li className="flex items-start" data-id="element-146">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-147">•</span>
              <span data-id="element-148">explicación clara de la efeméride</span>
            </li>
            <li className="flex items-start" data-id="element-149">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-150">•</span>
              <span data-id="element-151">origen de la conmemoración</span>
            </li>
            <li className="flex items-start" data-id="element-152">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-153">•</span>
              <span data-id="element-154">qué ocurrió y por qué se recuerda</span>
            </li>
            <li className="flex items-start" data-id="element-155">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-156">•</span>
              <span data-id="element-157">personajes históricos importantes</span>
            </li>
            <li className="flex items-start" data-id="element-158">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-159">•</span>
              <span data-id="element-160">explicación adaptada para niños</span>
            </li>
            <li className="flex items-start" data-id="element-161">
              <span className="text-blue-500 mr-3 font-bold" data-id="element-162">•</span>
              <span data-id="element-163">actividades para trabajar en clase</span>
            </li>
          </ul>

          <p className="text-lg font-bold text-gray-900 inline-block px-2 mb-2 bg-[#EFF6FF]" data-id="element-164">
            Todo pensado especialmente para Docentes de nivel Inicial y Primario
          </p>

          <p className="text-lg text-gray-700" data-id="element-165">
            El contenido está organizado para que puedas encontrar cada
            efeméride rápidamente y trabajarla en minutos.
          </p>
        </div>

        <div className="text-center mt-5" data-id="element-166">
          <CTAButton href="#compra" className="w-full md:w-auto" data-id="element-167">
            🔥 QUIERO RESOLVER MIS EFEMÉRIDES AHORA
          </CTAButton>
        </div>
      </div>
    </section>;
}